export const ActionTypes = {
  LOADING: "DELETE_CONS_LOADING",
  ERROR: "DELETE_CONS_ERROR",
  SUCCESS: "DELETE_CONS_SUCCESS",
};
